export const MONTHS = [
  { label: 'Jan', value: 0 },
  { label: 'Feb', value: 1 },
  { label: 'Mar', value: 2 },
  { label: 'Apr', value: 3 },
  { label: 'May', value: 4 },
  { label: 'Jun', value: 5 },
  { label: 'Jul', value: 6 },
  { label: 'Aug', value: 7 },
  { label: 'Sep', value: 8 },
  { label: 'Oct', value: 9 },
  { label: 'Nov', value: 10 },
  { label: 'Dec', value: 11 },
];

// generate years 2020–2030
export const YEARS = Array.from({ length: 11 }, (_, i) => 2020 + i);

export const REPORTING_TYPES = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
};

export const CALENDAR_OPTIONS = {
  ACTUAL: 'Actual',
  PLAN: 'Plan',
};

export const LAST_DATE = '9999-12-31 00:00:00';
